import gbAntPreviewImage from "./src/gb-ant-preview-image.vue";
const gbAntPreviewImageCompenet = function(Vue) {
  Vue.component(gbAntPreviewImage.name, gbAntPreviewImage);
};
export default gbAntPreviewImageCompenet;
